<template>
  <v-dialog :model-value="isVisible" width="600" @close="closeDialog" persistent>
    <v-form>
      <v-card v-if="assetContainer">
        <v-card-title class="d-flex flex-row ma-2">
          <h4 class="text-capitalize" data-testid="yard-asset-container-notes-dialog-title">
            {{ t('yard.dialogs.yardViewAssetContainerNotesDialog.headers.assetNotes') }}
          </h4>
          <v-spacer></v-spacer>
          <v-btn icon="mdi-close" variant="text" density="comfortable" @click="closeDialog"></v-btn>
        </v-card-title>
        <v-card-text>
          <div class="d-flex flex-column gap-6">
            <p class="typography-body-md">
              {{
                t(
                  'yard.dialogs.yardViewAssetContainerNotesDialog.messages.enterAnyAdditionalNotesAboutThisAssetThatYouWouldLikeToReferenceOrReportLater'
                )
              }}
            </p>

            <v-textarea
              v-model="observation"
              color="primary"
              data-testid="yard-asset-container-notes-dialog-observation-input"
              :label="t('yard.dialogs.yardViewAssetContainerNotesDialog.labels.assetNotes')"
              variant="outlined"
              :placeholder="`${t(
                'yard.dialogs.yardViewAssetContainerNotesDialog.placeholders.enterNotesHere'
              )}...`"
              density="compact"
              clearable
              maxlength="500"
              counter></v-textarea>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn
            variant="outlined"
            @click="closeDialog"
            data-testid="yard-asset-container-notes-dialog-cancel">
            {{ t('global.buttons.nevermind') }}
          </v-btn>
          <v-btn
            class="bg-primary"
            @click="submit"
            data-testid="yard-asset-container-notes-dialog-submit">
            {{ t('global.buttons.confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { defineComponent, ref, onMounted } from 'vue';
import useYard from '@/modules/yard/composables/useYard';
import { useNotify } from '@/composables';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'YardViewAssetContainerNotesDialog',
  props: {
    assetContainer: {
      type: Object,
      required: true
    },
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const { t } = useI18n();
    const yardStore = useYard();

    const observation = ref('');
    const notify = useNotify();

    const submit = async () => {
      try {
        yardStore.setIsLoadingAssetVisits(true);
        await axios.patch(`/asset-container/${props.assetContainer.id}`, {
          notes: observation.value
        });
        notify(
          t('yard.dialogs.yardViewAssetContainerNotesDialog.messages.notesAddedSuccesfully'),
          'success'
        );
        props.assetContainer.notes = observation.value;

        yardStore.trackMixpanelEvent(yardStore.MixPanelEvent.UPDATE_ASSET_CONTAINER, {
          entryPoint: 'Asset Container Form',
          spot: yardStore.selectedSpotRef.value,
          assetVisit: props.assetContainer
        });
      } catch (error) {
        notify(
          t('yard.dialogs.yardViewAssetContainerNotesDialog.messages.failedToAddNotes'),
          'error'
        );
        console.error(error);
        return;
      } finally {
        yardStore.setIsLoadingAssetVisits(false);
        closeDialog();
      }
    };

    const closeDialog = () => {
      context.emit('close');
    };

    onMounted(() => {
      observation.value = props.assetContainer.notes;
    });

    return {
      t,
      submit,
      closeDialog,
      observation
    };
  }
});
</script>
